/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import ReactMarkdown from 'react-markdown';

const FormattedText = ({ text }: { text: string }) => {
	return (
		<ReactMarkdown
			components={{
				a: ({ node, ...props }) => {
					const href = props.href || '';
					if (href.includes('#cite-')) {
						const isOutdated = href.includes('#cite-outdated');

						const className = `source-cite ${isOutdated ? 'outdated-cite' : ''}`;
						const [realHref] = href.split('#');
						return (
							<a href={realHref} target="_blank" rel="noreferrer noopener">
								<b className={className}>{props.children}</b>
							</a>
						);
					}
					return <a {...props} target="_blank" rel="noreferrer noopener" />;
				}
			}}
		>
			{text}
		</ReactMarkdown>
	);
};

export default FormattedText;
